import apiClient from "./apiClient/bingohome";
import {
  VerificationParams,
  VerificationResponse,
  saveTelephone4PersonParams,
} from "./types";
export async function loginPersonByWx(code: string, appid: string) {
  const res = await apiClient.post("login/loginPerson.do", null, {
    params: {
      code,
      appId: appid,
      loginType: 'wx',
      appName: 'react_worker',
    }
  });
  // @ts-ignore
  return res.data.data;
}

export async function loginByPersonId(personId: string) {
  const res = await apiClient.post('login/loginPersonByPersonId.do', null, {
    params: { personId }
  })
  return res.data.data;
}

export function sendVerificationCode(
  params: VerificationParams,
): Promise<{ data: VerificationResponse }> {
  return apiClient.post('getVerificationCodeByTelephone.do', null, { params });
}

export async function saveTelephone4Person(
  params: saveTelephone4PersonParams,
): Promise<{ returnCode: string }> {
  const res = await apiClient.post('saveTelephone4Person.do', null, { params });
  return res.data;
}